import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shown when wallet-specific data is unavailable — keeps pages usable.
 */
const GuestConnectPrompt = ({ title, description, primaryTo = '/bridge', primaryLabel = 'Explore Bridge' }) => (
  <div className="galaxia-card p-8 text-center">
    <h2 className="text-xl font-semibold mb-2" style={{ color: 'var(--galaxia-text)' }}>{title}</h2>
    <p className="text-sm max-w-lg mx-auto mb-6" style={{ color: 'var(--galaxia-muted)' }}>{description}</p>
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <Link to={primaryTo} className="galaxia-btn-primary px-5 py-3 text-sm font-medium inline-flex justify-center">
        {primaryLabel}
      </Link>
      <Link to="/" className="galaxia-btn-secondary px-5 py-3 text-sm font-medium inline-flex justify-center">
        Back to Dashboard
      </Link>
    </div>
  </div>
);

export default GuestConnectPrompt;
